import { render, staticRenderFns } from "./summarized.vue?vue&type=template&id=1b839445&scoped=true&"
import script from "./summarized.vue?vue&type=script&lang=js&"
export * from "./summarized.vue?vue&type=script&lang=js&"
import style0 from "./summarized.vue?vue&type=style&index=0&lang=css&"
import style1 from "./summarized.vue?vue&type=style&index=1&id=1b839445&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b839445",
  null
  
)

export default component.exports